import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { useSelector } from 'react-redux';
import { getQueryKeys } from './queryKeys';

const getFlatAvailable = async ({ houseId, companyId, flatId }) => {
  return await request.get(
    `/HousingStock/company/${companyId}/houses/${houseId}/flats/${flatId}/available`,
    null,
    'При загрузке доступа пользователя произошла ошибка'
  );
};

const useFlatAvailable = ({ flatId, houseId }, options) => {
  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  return useQuery(
    getQueryKeys.flatAvailable(houseId, currentCompany?.id, flatId),
    () => getFlatAvailable({ houseId, companyId: currentCompany?.id, flatId }),
    {
      enabled: Boolean(houseId && currentCompany?.id && flatId),
      ...options,
    }
  );
};

export default useFlatAvailable;
